import React, { useState, useEffect, useMemo } from "react";
import { Card, CardBody, Col, Container, DropdownItem, DropdownMenu, DropdownToggle, Nav, NavItem, NavLink, Row, TabContent, TabPane, UncontrolledDropdown } from "reactstrap";
import { Link, useParams } from "react-router-dom";
import classnames from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { fetchBookingsDetailsData } from "../../store/bookings/actions";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import BookingRouteMap from "../../components/Common/BookingRouteMap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

const BookingsDetails = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const { data, loading, error } = useSelector(state => state.Bookings.details);

    useEffect(() => {
        if (id) {
            dispatch(fetchBookingsDetailsData(id));
        }
    }, [dispatch, id]);

    // Custom Tabs Bordered
    const [customActiveTab, setcustomActiveTab] = useState("1");
    const toggleCustom = (tab) => {
        if (customActiveTab !== tab) {
            setcustomActiveTab(tab);
        }
    };

    const statusMap = {
        1: 'PENDING',
        2: 'ONGOING',
        3: 'ARRIVED',
        4: 'START',
        5: 'COMPLETE',
        6: 'CANCEL',
        7: 'EXPIRED',
        8: 'SCHEDULE',
        9: 'SCHEDULE ACCEPT',
    };

    const bookingTracking = {
        "booking_created": {
            "name": "Booking Created",
            "icon": "mdi mdi-calendar-plus",
            "class": "info",
        },
        "ongoing": {
            "name": "Booking Accepted",
            "icon": "mdi mdi-account-check-outline",
            "class": "warning",
        },
        "arrived": {
            "name": "Booking Arrived",
            "icon": "mdi mdi-map-marker-radius",
            "class": "secondary",
        },
        "hooked": {
            "name": "Hooked",
            "icon": "mdi mdi-car-outline",
            "class": "success",
        },
        "loading_proccess": {
            "name": "Loading Proccess",
            "icon": "mdi mdi-calendar-plus",
            "class": "purple",
        },
        "start": {
            "name": "Booking Started",
            "icon": "mdi mdi-car-outline",
            "class": "success",
        },
        "unloading_proccess": {
            "name": "Un-loading Proccess",
            "icon": "mdi mdi-calendar-plus",
            "class": "warning",
        },
        "complete": {
            "name": "Booking Complete",
            "icon": "mdi mdi-flag-checkered",
            "class": "dark",
        },
        "payment_collect": {
            "name": "Payment Collected",
            "icon": "mdi mdi-cash-multiple",
            "class": "success",
        },
    };

    document.title = "Bookings Details | Moeen";
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* Render Breadcrumbs */}
                    <Breadcrumbs maintitle="Home" title="Bookings" breadcrumbItem="Bookings Details" />

                    <Row>
                        <Col xl={3}>
                            <div className="user-sidebar">
                                {/* Booking Status */}
                                <Card className="text-white" style={{ backgroundColor: '#4caf50', border: 'none' }}>
                                    <div className="p-4">
                                        <h5 className="mb-0 text-center">
                                            <span className="text-uppercase">
                                                {loading ? (
                                                    <Skeleton width={80} />
                                                ) : (
                                                    statusMap[data?.data?.booking?.status] || 'PENDING'
                                                )}
                                            </span>
                                        </h5>
                                    </div>
                                </Card>

                                {/* Customer Card */}
                                <Card className="position-relative">
                                    <div
                                        className="position-absolute bg-t-success text-white px-3 py-1"
                                        style={{
                                            top: "10px",
                                            right: "-10px",
                                            borderTopLeftRadius: "0",
                                            borderBottomLeftRadius: "0",
                                            borderTopRightRadius: "8px",
                                            borderBottomRightRadius: "8px",
                                            zIndex: 1,
                                        }}
                                    >
                                        Customer
                                    </div>
                                    <CardBody>
                                        <div className="mt-n4 position-relative">
                                            <div className="text-center">
                                                {loading ? (
                                                    <Skeleton circle height={80} width={80} />
                                                ) : (
                                                    <img
                                                        src={data?.data?.customer?.image}
                                                        alt={data?.data?.customer?.name}
                                                        className="avatar-xl rounded-circle img-thumbnail"
                                                    />
                                                )}
                                                <div className="mt-3">
                                                    <h5>{loading ? <Skeleton width={100} /> : data?.data?.customer?.name}</h5>
                                                    <div>
                                                        {loading ? (
                                                            <Skeleton width={140} />
                                                        ) : (
                                                            <Link to="#" className="text-muted m-1">
                                                                {data?.data?.customer?.phone_code} {data?.data?.customer?.mobno}
                                                            </Link>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </CardBody>
                                </Card>

                                {/* Driver Card */}
                                <Card className="position-relative">
                                    <div
                                        className="position-absolute bg-t-success text-white px-3 py-1"
                                        style={{
                                            top: "10px",
                                            right: "-10px",
                                            borderTopLeftRadius: "0",
                                            borderBottomLeftRadius: "0",
                                            borderTopRightRadius: "8px",
                                            borderBottomRightRadius: "8px",
                                            zIndex: 1,
                                        }}
                                    >
                                        Driver
                                    </div>
                                    <CardBody>
                                        <div className="mt-n4 position-relative">
                                            <div className="text-center">
                                                {loading ? (
                                                    <Skeleton circle height={80} width={80} />
                                                ) : (
                                                    <img
                                                        src={data?.data?.driver?.image}
                                                        alt={data?.data?.driver?.name}
                                                        className="avatar-xl rounded-circle img-thumbnail"
                                                    />
                                                )}
                                                <div className="mt-3">
                                                    <h5>{loading ? <Skeleton width={100} /> : data?.data?.driver?.name}</h5>
                                                    <div>
                                                        {loading ? (
                                                            <Skeleton width={140} />
                                                        ) : (
                                                            <Link to="#" className="text-muted m-1">
                                                                {data?.data?.driver?.phone_code} {data?.data?.driver?.mobno}
                                                            </Link>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </CardBody>
                                </Card>

                                {/* Vehicle Card */}
                                <Card className="position-relative">
                                    <div
                                        className="position-absolute bg-t-success text-white px-3 py-1"
                                        style={{
                                            top: "10px",
                                            right: "-10px",
                                            borderTopLeftRadius: "0",
                                            borderBottomLeftRadius: "0",
                                            borderTopRightRadius: "8px",
                                            borderBottomRightRadius: "8px",
                                            zIndex: 1,
                                        }}
                                    >
                                        Vehicle
                                    </div>
                                    <CardBody>
                                        <div className="mt-n4 position-relative">
                                            <div className="text-center">
                                                {loading ? (
                                                    <Skeleton circle height={80} width={80} />
                                                ) : (
                                                    <img
                                                        src={data?.data?.vehicle?.vehicle_media?.[0]?.url}
                                                        alt={data?.data?.vehicle?.make_name}
                                                        className="avatar-xl rounded-circle img-thumbnail"
                                                    />
                                                )}
                                                <div className="mt-3">
                                                    <h5>
                                                        {loading ? (
                                                            <Skeleton width={120} />
                                                        ) : (
                                                            `${data?.data?.vehicle?.make_name} - ${data?.data?.vehicle?.body_type}`
                                                        )}
                                                    </h5>
                                                    <div>
                                                        {loading ? (
                                                            <Skeleton width={160} />
                                                        ) : (
                                                            <Link to="#" className="text-muted m-1">
                                                                {data?.data?.vehicle?.license_plate} - {data?.data?.vehicle?.type_name}
                                                            </Link>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </CardBody>
                                </Card>
                            </div>
                        </Col>

                        <Col xl={9}>

                            <Card>
                                <Nav tabs className="nav nav-tabs nav-tabs-custom nav-justified">
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                                active: customActiveTab === "1",
                                            })}
                                            onClick={() => {
                                                toggleCustom("1");
                                            }}
                                        >
                                            <i className="bx bx-user-circle font-size-20"></i>
                                            <span className="d-none d-sm-block">Location</span>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                                active: customActiveTab === "2",
                                            })}
                                            onClick={() => {
                                                toggleCustom("2");
                                            }}
                                        >
                                            <i className="bx bx-clipboard font-size-20"></i>
                                            <span className="d-none d-sm-block">Tracking</span>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                                active: customActiveTab === "3",
                                            })}
                                            onClick={() => {
                                                toggleCustom("3");
                                            }}
                                        >
                                            <i className="bx bx-mail-send font-size-20"></i>
                                            <span className="d-none d-sm-block">Fares</span>
                                        </NavLink>
                                    </NavItem>
                                </Nav>

                                <TabContent
                                    activeTab={customActiveTab}
                                    className="p-4"
                                >
                                    <TabPane tabId="1">

                                        <div>
                                            <div>
                                                <h5 className="font-size-16 mb-4">Locations</h5>

                                                <ol className="activity-checkout mb-0 px-4 mt-3">
                                                    <li className="checkout-item">
                                                        <div className="avatar-sm checkout-icon p-1">
                                                            <div className="avatar-title rounded-circle bg-primary">
                                                                <i className="mdi mdi-map-marker text-white font-size-20"></i>
                                                            </div>
                                                        </div>
                                                        <div className="feed-item-list">
                                                            <div>
                                                                <h5 className="font-size-16 mb-1">{loading ? <Skeleton width={200} /> : data?.data?.booking?.pickup_addr}</h5>
                                                                {loading ? (
                                                                    <Skeleton width={150} />
                                                                ) : data?.data?.booking?.tracking?.[1]?.datetime && (
                                                                    <p className="text-muted text-truncate mb-2">
                                                                        {data.data.booking.tracking[1].datetime}
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </li>

                                                    <li className="checkout-item">
                                                        <div className="avatar-sm checkout-icon p-1">
                                                            <div className="avatar-title rounded-circle bg-primary">
                                                                <i className="mdi mdi-map-marker-check text-white font-size-20"></i>
                                                            </div>
                                                        </div>
                                                        <div className="feed-item-list">

                                                            <h5 className="font-size-16 mb-1">{loading ? <Skeleton width={200} /> : data?.data?.booking?.dest_addr}</h5>
                                                            {loading ? (
                                                                <Skeleton width={150} />
                                                            ) : data?.data?.booking?.tracking?.[5]?.datetime && (
                                                                <p className="text-muted text-truncate mb-2">
                                                                    {data.data.booking.tracking[5].datetime}
                                                                </p>
                                                            )}
                                                        </div>
                                                    </li>

                                                </ol>
                                            </div>

                                            <div>
                                                <h5 className="font-size-16 mb-4">Map</h5>
                                                {loading ? (
                                                    <Skeleton height={300} />
                                                ) : (
                                                    <BookingRouteMap
                                                        src_lat={data?.data?.booking?.source_lat}
                                                        src_lng={data?.data?.booking?.source_long}
                                                        dest_lat={data?.data?.booking?.dest_lat}
                                                        dest_lng={data?.data?.booking?.dest_long}
                                                    />
                                                )}
                                            </div>
                                        </div>

                                    </TabPane>
                                    <TabPane tabId="2">

                                        <div>
                                            <div>
                                                <h5 className="font-size-16 mb-4">Booking Tracking</h5>

                                                <ol className="activity-checkout mb-0 px-4 mt-3">

                                                    {data?.data?.booking?.tracking?.map((track, index) => {
                                                        const trackInfo = bookingTracking[track.status];
                                                        if (!trackInfo) return null;

                                                        return (
                                                            <li key={index} className="checkout-item">
                                                                <div className="avatar-sm checkout-icon p-1">
                                                                    <div className={`avatar-title rounded-circle bg-${trackInfo.class}`}>
                                                                        <i className={`${trackInfo.icon} text-white font-size-20`}></i>
                                                                    </div>
                                                                </div>
                                                                <div className="feed-item-list">
                                                                    <h5 className="font-size-16 mb-1">{trackInfo.name}</h5>
                                                                    {track.datetime && (
                                                                        <p className="text-muted text-truncate mb-2">{track.datetime}</p>
                                                                    )}
                                                                </div>
                                                            </li>
                                                        );
                                                    })}

                                                    {/* <li className="checkout-item">
                                                        <div className="avatar-sm checkout-icon p-1">
                                                            <div className="avatar-title rounded-circle bg-warning">
                                                                <i className="text-white font-size-20"></i>
                                                            </div>
                                                        </div>
                                                        <div className="feed-item-list">
                                                            <h5 className="font-size-16 mb-1">Booking Accepted</h5>
                                                            {data?.data?.booking?.tracking?.[1]?.datetime && (
                                                                <p className="text-muted text-truncate mb-2">
                                                                    {data.data.booking.tracking[1].datetime}
                                                                </p>
                                                            )}
                                                        </div>
                                                    </li>

                                                    <li className="checkout-item">
                                                        <div className="avatar-sm checkout-icon p-1">
                                                            <div className="avatar-title rounded-circle bg-secondary">
                                                                <i className="text-white font-size-20"></i>
                                                            </div>
                                                        </div>
                                                        <div className="feed-item-list">
                                                            <h5 className="font-size-16 mb-1">Booking Arrived</h5>
                                                            {data?.data?.booking?.tracking?.[2]?.datetime && (
                                                                <p className="text-muted text-truncate mb-2">
                                                                    {data.data.booking.tracking[2].datetime}
                                                                </p>
                                                            )}
                                                        </div>
                                                    </li>

                                                    <li className="checkout-item">
                                                        <div className="avatar-sm checkout-icon p-1">
                                                            <div className="avatar-title rounded-circle bg-success">
                                                                <i className="text-white font-size-20"></i>
                                                            </div>
                                                        </div>
                                                        <div className="feed-item-list">
                                                            <h5 className="font-size-16 mb-1">Booking Started</h5>
                                                            {data?.data?.booking?.tracking?.[3]?.datetime && (
                                                                <p className="text-muted text-truncate mb-2">
                                                                    {data.data.booking.tracking[3].datetime}
                                                                </p>
                                                            )}
                                                        </div>
                                                    </li>

                                                    <li className="checkout-item">
                                                        <div className="avatar-sm checkout-icon p-1">
                                                            <div className="avatar-title rounded-circle bg-dark">
                                                                <i className="text-white font-size-20"></i>
                                                            </div>
                                                        </div>
                                                        <div className="feed-item-list">
                                                            <h5 className="font-size-16 mb-1">Booking Complete</h5>
                                                            {data?.data?.booking?.tracking?.[4]?.datetime && (
                                                                <p className="text-muted text-truncate mb-2">
                                                                    {data.data.booking.tracking[4].datetime}
                                                                </p>
                                                            )}
                                                        </div>
                                                    </li>

                                                    <li className="checkout-item">
                                                        <div className="avatar-sm checkout-icon p-1">
                                                            <div className="avatar-title rounded-circle bg-success">
                                                                <i className="text-white font-size-20"></i>
                                                            </div>
                                                        </div>
                                                        <div className="feed-item-list">
                                                            <h5 className="font-size-16 mb-1">Payment Collected</h5>
                                                            {data?.data?.booking?.tracking?.[5]?.datetime && (
                                                                <p className="text-muted text-truncate mb-2">
                                                                    {data.data.booking.tracking[5].datetime}
                                                                </p>
                                                            )}
                                                        </div>
                                                    </li> */}
                                                </ol>

                                            </div>
                                        </div>

                                    </TabPane>
                                    <TabPane tabId="3">

                                        <div>
                                            <h5 className="font-size-16 mb-4">Fare Summary</h5>
                                            <div className="table-responsive">
                                                <table className="table table-bordered mb-0">
                                                    <tbody>
                                                        <tr>
                                                            <th>Pickup Location</th>
                                                            <td>{data?.data?.booking?.pickup_addr}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Drop-off Location</th>
                                                            <td>{data?.data?.booking?.dest_addr}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Booking Type</th>
                                                            <td className="text-capitalize">{data?.data?.booking?.type}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Distance</th>
                                                            <td>{data?.data?.booking?.total_kms} km</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Base Fare</th>
                                                            <td>Rs. {data?.data?.booking?.base_fare?.toFixed(2)}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Standard Fare (Distance)</th>
                                                            <td>Rs. {data?.data?.booking?.std_fare?.toFixed(2)}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Time Fare</th>
                                                            <td>Rs. {data?.data?.booking?.time_rate?.toFixed(2)}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Other Charges</th>
                                                            <td>Rs. {data?.data?.booking?.other_fee?.toFixed(2)}</td>
                                                        </tr>
                                                        <tr className="table-active font-weight-bold">
                                                            <th>Total Fare</th>
                                                            <td>Rs. {data?.data?.booking?.total_amount?.toFixed(2)}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Payment Method</th>
                                                            <td className="text-capitalize">{data?.data?.booking?.payment_method}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Payment Status</th>
                                                            <td className="text-capitalize">{data?.data?.booking?.payment_status == 1 ? 'PAID' : 'NOT PAID'}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                    </TabPane>
                                </TabContent>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default BookingsDetails;
